import React from 'react';
import PropTypes from 'prop-types';

import useHasBookingInRange from 'queries/Booking/useHasBookingInRange';
import HasBookingInRangeContext from './HasBookingInRangeContext';
import useCar from './useCar';
import { useSelector } from 'react-redux';
import { authSelectors } from 'store/selectors';

const HasBookingInRangeProvider = ({ children }) => {
	const { pickupDate, dropDate } = useCar();

	const isAuthenticated = useSelector(authSelectors.isAuthenticated);

	const { data, isLoading, isError } = useHasBookingInRange(
		isAuthenticated,
		pickupDate,
		dropDate
    );
    
    const isLoaded = !!data;

	return (
		<HasBookingInRangeContext.Provider
			value={{
                hasBookingInRange: data?.hasBookings,
                isLoaded,
				isLoading,
				isError
			}}
		>
			{children}
		</HasBookingInRangeContext.Provider>
	);
};

HasBookingInRangeProvider.propTypes = {
	children: PropTypes.node
};

export default HasBookingInRangeProvider;
